(function () {
    "use strict";

    angular
        .module('reports', [
            'ngAnimate',
            'ngMessages',
            'ui.bootstrap',
            'ui.validate',
            app.modules.common.name
        ]);
})();

